let subscribers = {};

window.PUB_SUB_EVENTS = {
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
};

window.subscribe = function (eventName, callback) {
  if (!subscribers[eventName]) {
    subscribers[eventName] = [];
  }
  subscribers[eventName].push(callback);

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
};

window.publish = function (eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => callback(data));
    return Promise.all(promises);
  }
  return Promise.resolve();
};
